const Footer = () => {
    return(
       <div className="relative w-full h-[25vh] flex justify-center items-center text-sm pb-4">
         <p className="absolute bottom-0 block pb-4 text-center ">&copy; 2025 U.C HUB, All rights reserved</p>
       </div>
    )
}

export default Footer
